<svg class="app_icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_648)">
        <path
            d="M7.10342 18.9407C6.47893 18.941 5.88002 18.6928 5.43881 18.2508L0.406139 13.22C-0.13538 12.6783 -0.13538 11.8002 0.406139 11.2586C0.947831 10.717 1.82591 10.717 2.36761 11.2586L7.10342 15.9944L19.6324 3.4654C20.1741 2.92389 21.0522 2.92389 21.5939 3.4654C22.1354 4.0071 22.1354 4.88518 21.5939 5.42687L8.76803 18.2508C8.32683 18.6928 7.72791 18.941 7.10342 18.9407Z"
            fill="white" />
    </g>
    <defs>
        <clipPath id="clip0_1_648">
            <rect width="22" height="22" fill="white" />
        </clipPath>
    </defs>
</svg>